import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// JS Files
import MuiButton from "../shares/MuiButton";

// Others File

const ServicesCard = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="mt-4 md:mt-0 flex flex-col justify-center items-center">
        <div
          className=" z-10	flex justify-center items-center rounded-full  w-24 h-24"
          style={{ backgroundColor: "#FCFCFC" }}
        >
          <div className="flex justify-center items-center rounded-full border-2 border-myorange-500  w-20 h-20">
            <img src={props.icon} />
          </div>
        </div>
        <div
          className="-mt-8 bg-white rounded-lg text-center p-8"
          style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
        >
          <p className="text-mygray-700 font-bold text-xl mt-4">
            {props.header}
          </p>
          <br />
          <span className="text-sm leading-8 text-mygray-500">
            {props.text}
          </span>
          <div className="flex justify-center mt-4">
            <div>
              <MuiButton
                onClick={() => navigate(`/record/${props.type}`)}
                type="submit"
                variant="contained"
                color="primary"
                text="ثبت"
              />
            </div>
            <div className="mr-4">
              <MuiButton
                onClick={() => navigate(`/follow-up/${props.type}`)}
                type="submit"
                variant="outlined"
                color="primary"
                text="پیگیری"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ServicesCard;
